import * as tslib_1 from "tslib";
import getMailListHeader from './getMailListHeader';
import { observer } from 'mobx-react';
import { logUsage } from 'owa-analytics';
import { LightningId } from 'owa-lightning-v2';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { TurnOffFocusedOtherItem } from 'owa-mail-focus-other-off-view';
import { focusedInboxRollupStore } from 'owa-mail-focused-inbox-rollup-store';
import { FocusedInboxRollup, shouldShowStickyFocusedRollup, } from 'owa-mail-focused-inbox-rollup-view';
import { isFocusedInboxEnabled } from 'owa-mail-list-actions/lib/utils/FocusedInboxUtil';
import { getFocusedFilterForTable, listViewStore } from 'owa-mail-list-store';
import MailList from 'owa-mail-list-view/lib/components/MailList';
import { NotificationBarHost } from 'owa-notification-bar';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { UpNext } from 'owa-upnext';
import * as React from 'react';
import { MAX_LIST_VIEW_HEIGHT, MAX_LIST_VIEW_WIDTH, MIN_LIST_VIEW_HEIGHT, MIN_LIST_VIEW_WIDTH, } from 'owa-mail-list-dimensions';
import strings from 'owa-strings/owa-mail-strings';
import isReadingPanePositionRight from '../selectors/isReadingPanePositionRight';
var ListPane = /** @class */ (function (_super) {
    tslib_1.__extends(ListPane, _super);
    function ListPane() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListPane.prototype.render = function () {
        return (React.createElement("div", { role: 'region', "aria-label": strings.messageListLabel, tabIndex: -1, style: this.props.style, className: this.props.className, "data-min-width": MIN_LIST_VIEW_WIDTH, "data-min-height": MIN_LIST_VIEW_HEIGHT, "data-max-width": MAX_LIST_VIEW_WIDTH, "data-max-height": MAX_LIST_VIEW_HEIGHT },
            getMailListHeader(this.props.tableViewId),
            shouldRenderTurnOffFocusedOther(this.props.tableViewId) && (React.createElement(TurnOffFocusedOtherItem, { lid: LightningId.FocusOtherOff, when: function (lightup) { return lightup(); } })),
            shouldShowStickyFocusedRollup(this.props.tableViewId) && (React.createElement(FocusedInboxRollup, { key: "rollup", rollupState: focusedInboxRollupStore })),
            isMailFeatureEnabled('tri-upNext') && React.createElement(UpNext, null),
            React.createElement(MailList, { key: "listpane_list", tableViewId: this.props.tableViewId }),
            (isMailFeatureEnabled('tri-notificationBar') ||
                isMailFeatureEnabled('cmp-delaySend')) &&
                isReadingPanePositionRight() && React.createElement(NotificationBarHost, null),
            this.props.tabBar));
    };
    ListPane = tslib_1.__decorate([
        observer
    ], ListPane);
    return ListPane;
}(React.Component));
export default ListPane;
// Turn off focus other dialog is shown for users who have focus/other on. It's shown for
// a maximum of 3 sessions then never again. If a user has focus/other off, we still need to
// render the dialog so we can silently remove the lightning id for that user to prevent the
// dialog from ever showing in the future.
function shouldRenderTurnOffFocusedOther(tableViewId) {
    var tableView = listViewStore.tableViews.get(tableViewId);
    // If user is not in flight or not in inbox, we do not want to show the dialog or
    // remove their lightning id.
    if (!isMailFeatureEnabled('tri-turnOffFocusedOther') ||
        tableView.tableQuery.folderId != folderNameToId('inbox')) {
        return false;
    }
    // Special case: the user has F/O on but have not received an email in Other yet.
    // The pivot will not be shown until they receive an email for other, and we only
    // want to show it when that happens. Until then, don't render the component so we
    // remove their lightning id without them seeing it
    if (isFocusedInboxEnabled() && getFocusedFilterForTable(tableView) == -1 /* None */) {
        logUsage('TurnOffFO_NoItemsInOther');
        return false;
    }
    // Cases where we render the component
    // 1) User has focus/other on and we want to show it and increment their session count
    // 2) User has focus/other off and we silently remove their lightning id from the render
    //    function without actually showing the component
    return true;
}
//# sourceMappingURL=ListPane.js.map